export default "<p>hot-news works!</p>\n"